import { useState } from "react";
import { ExportAccountDataModal } from "./ExportAccountDataModal";
import { ArrowInSquareIcon } from "../../images";
import { EllipsisTooltip } from "../CustomTooltip";
import { useAppSelector } from "../../../hooks";
import { selectPermissions } from "../../../features/permissionsSlice";
import { useGetCampaignDetailsQuery } from "../../../api";
import { ReuseButton } from "../ReuseButton";

export const ExportAccountDataBtn = ({
  account_id,
  campaign_id,
  is_analyzed,
  total_members_with_playbook,
}: {
  account_id: string;
  campaign_id: string;
  is_analyzed: boolean;
  total_members_with_playbook: number;
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { isAllowedExportContactsAccountsList, isAllowedExportPlaybooks } =
    useAppSelector(selectPermissions);

  const { data } = useGetCampaignDetailsQuery(
    { account_id: account_id! },
    { skip: !account_id },
  );

  const isDisabled =
    (!is_analyzed && total_members_with_playbook === 0) ||
    (!is_analyzed && total_members_with_playbook > 0) ||
    (!isAllowedExportContactsAccountsList && !isAllowedExportPlaybooks);

  return (
    <>
      <EllipsisTooltip
        tooltip={
          !is_analyzed && total_members_with_playbook === 0
            ? "You haven’t analysed company yet"
            : "Export"
        }
      >
        <ReuseButton
          onClick={() => setIsOpen(true)}
          disabled={isDisabled}
          sx={{ paddingX: "6px", minWidth: 0 }}
        >
          <ArrowInSquareIcon color={isDisabled ? "#9B9B9B" : undefined} />
        </ReuseButton>
      </EllipsisTooltip>

      {isOpen && (
        <ExportAccountDataModal
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          account_id={account_id}
          campaign_id={campaign_id}
          total_members_with_playbook={total_members_with_playbook}
          isOnlyPlaybook={!is_analyzed && total_members_with_playbook > 0}
          hidePlaybook={!isAllowedExportPlaybooks}
          dataSourceList={data?.data_source || []}
        />
      )}
    </>
  );
};
